module.exports = __webpack_public_path__ + "8e53d520f79ba10f5e912ecadb048098.png";